import {
  Box,
  Checkbox,
  Dialog,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import CustomTextField from "../../../../Components/CustomTextField/CustomTextField";
import CustomSubmitButton from "../../../../Components/CustomSubmitButton/CustomSubmitButton";
import { DATABASE } from "../../../../Config/firebase";
import {
  doc,
  getDoc,
  getDocs,
  collection,
  query,
  where,
  serverTimestamp,
  Timestamp,
  updateDoc,
    runTransaction,
    increment,
} from "firebase/firestore";
import { dolorFormatAmount } from "../../../../Utils/Services";
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";
const FullWithdrawModel = (props) => {
  const { open, onClose, offerAmountDetails, handleOfferAmountOnSubmit } =
    props;
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [value, setValue] = useState(0);
  const [type, setType] = useState(0);
  const [responseTime, setResponseTime] = useState(60);
  const [customTime, setCustomTime] = useState('');
  const [originalBalance, setOriginalBalance] = useState(0);
  
  // Get original balance from transaction or fetch from user
  useEffect(() => {
    const fetchOriginalBalance = async () => {
      if (offerAmountDetails?.original_balance) {
        setOriginalBalance(offerAmountDetails.original_balance);
      } else if (offerAmountDetails?.user_id) {
        try {
          const userDoc = await getDoc(doc(DATABASE, "users", offerAmountDetails.user_id));
          if (userDoc.exists()) {
            // Use current balance + requested amount to approximate original balance
            // (since balance was already deducted when OTP was verified)
            const currentBalance = userDoc.data()?.net_balance || 0;
            const requestedAmount = offerAmountDetails?.total_amount || 0;
            setOriginalBalance(currentBalance + requestedAmount);
          }
        } catch (error) {
          console.error("Error fetching user balance:", error);
          // Fallback to requested amount if we can't fetch
          setOriginalBalance(offerAmountDetails?.total_amount || 0);
        }
      } else {
        setOriginalBalance(offerAmountDetails?.total_amount || 0);
      }
    };
    if (offerAmountDetails) {
      fetchOriginalBalance();
    }
  }, [offerAmountDetails]);
  
  const is_Offer_Price = originalBalance; // Use original balance for calculation
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    if (checked) {
      setType(name === "Profit" ? 1 : 2);
    } else {
      setType(0);
    }
  };
  const handlePositiveNumberChange = (e) => {
    const { name, value } = e.target;

    const validValue = value === "" || /^\d+(\.\d{0,2})?$/.test(value);

    if (validValue) {
      formik.setFieldValue(name, value);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: "",
      profit_loss_percent: "",
    },
    validationSchema: Yup.object().shape({
      amount: Yup.number()
        .required("Amount is required")
        .positive("Amount must be positive"),
      // .max(
      //   is_Offer_Price,
      //   `Amount cannot be greater than ${"full withdraw"}`
      // ),
      profit_loss_percent: Yup.number().required(
        "Profit Loss Percent is required"
      ),
      // .positive("Amount must be positive")
      // .max(
      //   is_Offer_Price,
      //   `Amount cannot be greater than ${"full withdraw"}`
      // ),
    }),
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);
      if (isLoading) return;
      else {
        try {
          if (offerAmountDetails?.request_status === 1) {
            const userDoc = await getDoc(
              doc(DATABASE, "users", offerAmountDetails.user_id)
            );
            if (!userDoc.exists()) {
              throw new Error("User does not exist");
            }
          }
          
          // Calculate available balance after loss and actual withdrawal amount
          const requestedAmount = parseFloat(offerAmountDetails?.total_amount || 0);
          const profitLossPercent = type === 2 
            ? -Math.abs(values.profit_loss_percent) 
            : Math.abs(values.profit_loss_percent);
          
          // Calculate loss on original balance
          const lossAmount = originalBalance * (profitLossPercent / 100);
          
          // Calculate balance after loss (available balance)
          const balanceAfterLoss = originalBalance + lossAmount; // loss is negative, so this subtracts
          
          // Calculate actual withdrawal amount (cannot exceed available balance)
          // If requested amount > available balance, use available balance (account closure scenario)
          // This allows admin to send offers even when balance after loss < requested amount
          const actualWithdrawalAmount = Math.max(0, Math.min(requestedAmount, balanceAfterLoss));
          
          // Check if adjustment is needed (requested > available)
          const needsAdjustment = actualWithdrawalAmount < requestedAmount;
          
          // Show warning if adjustment is needed
          if (needsAdjustment) {
            toast.warning(
              `Withdrawal amount will be adjusted: Client requested $${requestedAmount.toFixed(2)}, but available balance after loss is $${balanceAfterLoss.toFixed(2)}. Client will receive $${actualWithdrawalAmount.toFixed(2)}.`,
              { autoClose: 7000 }
            );
          }
          
          // Determine if this is a full withdrawal (100% of original balance)
          // Use the is_full_withdraw value from the transaction if available, otherwise calculate it
          const isFullWithdrawal = offerAmountDetails?.is_full_withdraw === true 
            || (originalBalance > 0 && Math.abs(requestedAmount - originalBalance) < 0.01); // Allow small floating point differences
          
          const finalResponseTime = responseTime === 'custom' ? parseInt(customTime) || 60 : responseTime;
          const expiresAt = Timestamp.fromDate(new Date(Date.now() + finalResponseTime * 60 * 1000));
          
          // Save actual withdrawal amount as offered_amount
          // This is the amount the client will actually receive (may be less than requested)
          const updateData = {
            offered_amount: actualWithdrawalAmount, // Actual amount that will be withdrawn (may be adjusted)
            request_status: offerAmountDetails?.request_status,
            request_approval_time: serverTimestamp(),
            profit_loss_percent: profitLossPercent,
            original_balance: originalBalance, // CRITICAL: Save original balance for loss calculation
            conditional_expires_at: expiresAt,
            conditional_response_time_minutes: finalResponseTime,
            is_full_withdraw: isFullWithdrawal, // Use actual value: true for full withdrawal, false for >80% but not full
            conditional_offer_sent: true, // Flag to trigger email notification
            withdrawal_adjusted: needsAdjustment, // Flag to indicate adjustment was made
          };
          await updateDoc(
            doc(DATABASE, "transection_requests", offerAmountDetails?.doc_id),
            updateData
          );
          
          if (needsAdjustment) {
            toast.info(
              `Offer sent: Client will receive $${actualWithdrawalAmount.toFixed(2)} (adjusted from requested $${requestedAmount.toFixed(2)})`,
              { autoClose: 5000 }
            );
          } else {
            toast.success("Conditional offer sent successfully");
          }
          
          handleOfferAmountOnSubmit();
        } catch (error) {
          console.error("Error updating withdraw status:", error);
          toast.error(error.message || "Something went wrong. Try again!", {
            autoClose: 3000,
          });
        } finally {
          setIsLoading(false);
          resetForm();
        }
      }
    },
  });
  useEffect(() => {
    const percent = parseFloat(formik.values.profit_loss_percent);
    if (type === 1 && percent > 0) {
      // Profit: Calculate on original balance
      const calculatedAmount =
        is_Offer_Price + (is_Offer_Price * percent) / 100;
      formik.setFieldValue("amount", calculatedAmount);
    } else if (type === 2 && percent > 0) {
      // Loss: Calculate on original balance
      // This shows what the balance will be after loss is applied
      const calculatedAmount =
        is_Offer_Price - (is_Offer_Price * percent) / 100;
      formik.setFieldValue("amount", calculatedAmount);
    } else {
      formik.setFieldValue("amount", "");
    }
  }, [formik.values.profit_loss_percent, type, is_Offer_Price]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "20px",
          padding: "20px 30px",
          height: value === 0 ? "auto" : "300px",
          overflow: "scroll",
          "::-webkit-scrollbar": { width: "0px", height: "0px" },
        },
        "& .MuiDialogContent-root": {
          overflowY: "initial",
        },
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.8)",
        },
      }}
    >
      {/* <Tabs value={value} onChange={handleTabChange} variant="fullWidth">
        <Tab label="Offer Amount" />
        <Tab label="Full Withdraw" />
      </Tabs> */}
      {/* {value === 0 && ( */}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          formik.handleSubmit();
          return false;
        }}
        style={{
          paddingTop: "20px",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: "500",
                color: "#101010",
                fontFamily: "Outfit",
              }}
            >
              Original Balance : $
              {dolorFormatAmount(originalBalance)}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: "500",
                color: "#101010",
                fontFamily: "Outfit",
              }}
            >
              Requested Amount : $
              {dolorFormatAmount(offerAmountDetails?.total_amount)}
            </Typography>
          </Grid>
          {/* <Grid item xs={6}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              ></Box>
            </Grid> */}
        </Grid>
        <Box
          sx={{
            padding: "20px 0px 0px 0px",
          }}
        >
          <Grid spacing={2} container>
            <Grid item xs={12}>
              <FormGroup>
                <Box sx={{ display: "flex" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="Profit"
                        checked={type === 1}
                        onChange={handleCheckboxChange}
                      />
                    }
                    label="Profit"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="Loss"
                        checked={type === 2}
                        onChange={handleCheckboxChange}
                      />
                    }
                    label="Loss"
                  />
                </Box>
                <CustomTextField
                  type="number"
                  min="0"
                  max="1"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  onKeyDown={(evt) =>
                    ["e", "E", "+", "-"].includes(evt.key) &&
                    evt.preventDefault()
                  }
                  placeholder={
                    type === 1
                      ? "Enter Profit Percentage %"
                      : type === 2
                      ? "Enter Loss Percentage %"
                      : "Enter Percentage %"
                  }
                  name="profit_loss_percent"
                  value={formik.values.profit_loss_percent}
                  onBlur={formik.handleBlur}
                  onKeyUp={formik.handleBlur}
                  errors={
                    formik.touched.profit_loss_percent &&
                    formik.errors.profit_loss_percent
                  }
                  onChange={(e) => {
                    handlePositiveNumberChange(e);
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      borderRadius: "10px",
                      border: "1px solid #CACACA",
                      color: "black",
                      fontSize: "18px",
                      background: "white",
                      fontFamily: "Outfit",
                      // display: type === 1 || type === 2 ? "block" : "none",
                    },
                  }}
                  style={{ color: "black", fontSize: "18px" }}
                  isLoading={isLoading}
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12}>
              <CustomTextField
                disabled={true}
                label={
                  type === 1
                    ? "Balance after Profit"
                    : type == 2
                    ? "Balance after Loss (Client will see this)"
                    : "Balance"
                }
                type="text"
                placeholder="Enter Amount"
                name="amount"
                value={`$${dolorFormatAmount(formik.values.amount)}`}
                onBlur={formik.handleBlur}
                onKeyUp={formik.handleBlur}
                errors={formik.touched.amount && formik.errors.amount}
                sx={{
                  "& .MuiInputBase-root": {
                    borderRadius: "10px",
                    border: "1px solid #CACACA",
                    color: "black",
                    fontSize: "18px",
                    background: "white",
                    fontFamily: "Outfit",
                  },
                }}
                style={{ color: "black", fontSize: "18px" }}
                isLoading={isLoading}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: formik.values.amount && offerAmountDetails?.total_amount && parseFloat(formik.values.amount) < parseFloat(offerAmountDetails.total_amount)
                    ? "#ff9800" // Orange for warning
                    : "#666",
                  fontFamily: "Outfit",
                  fontStyle: "italic",
                  fontWeight: formik.values.amount && offerAmountDetails?.total_amount && parseFloat(formik.values.amount) < parseFloat(offerAmountDetails.total_amount)
                    ? "bold"
                    : "normal",
                }}
              >
                {formik.values.amount && offerAmountDetails?.total_amount && parseFloat(formik.values.amount) < parseFloat(offerAmountDetails.total_amount)
                  ? `⚠️ Withdrawal will be adjusted: Client requested $${dolorFormatAmount(offerAmountDetails.total_amount)}, but will receive $${dolorFormatAmount(formik.values.amount)}`
                  : `Actual withdrawal amount: $${dolorFormatAmount(
                      formik.values.amount && offerAmountDetails?.total_amount
                        ? Math.min(parseFloat(formik.values.amount), parseFloat(offerAmountDetails.total_amount))
                        : offerAmountDetails?.total_amount || 0
                    )}`}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Response Time</InputLabel>
                <Select
                  value={responseTime}
                  onChange={(e) => setResponseTime(e.target.value)}
                  label="Response Time"
                >
                  <MenuItem value={15}>15 minutes</MenuItem>
                  <MenuItem value={30}>30 minutes</MenuItem>
                  <MenuItem value={60}>1 hour (default)</MenuItem>
                  <MenuItem value={120}>2 hours</MenuItem>
                  <MenuItem value={240}>4 hours</MenuItem>
                  <MenuItem value="custom">Custom</MenuItem>
                </Select>
              </FormControl>
              
              {responseTime === 'custom' && (
                <CustomTextField
                  label="Custom Time (minutes)"
                  type="number"
                  placeholder="Enter minutes"
                  name="custom_time"
                  value={customTime}
                  onChange={(e) => setCustomTime(e.target.value)}
                  sx={{
                    "& .MuiInputBase-root": {
                      borderRadius: "10px",
                      border: "1px solid #CACACA",
                      color: "black",
                      fontSize: "18px",
                      background: "white",
                      fontFamily: "Outfit",
                    },
                    mb: 2
                  }}
                />
              )}
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <CustomSubmitButton
                    disabled={formik.values.profit_loss_percent == 0}
                    btnTitle={"Submit Conditions"}
                    loading={isLoading}
                    type="submit"
                  />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <CustomSubmitButton
                    btnTitle={"Reject"}
                    loading={isLoading2}
                    type="button"
                    onSubmit={async () => {
                      setIsLoading2(true);
                      try {
                        // CRITICAL: Restore balance if it was deducted (same logic as normal withdrawal rejection)
                        const txnDoc = await getDoc(doc(DATABASE, "transection_requests", offerAmountDetails?.doc_id));
                        const txnData = txnDoc.data();
                        
                        // Restore balance if OTP was verified (balance was definitely deducted)
                        if (txnData?.otp_verify === true && txnData?.balance_restored !== true) {
                          const amountToRestore = parseFloat(offerAmountDetails?.total_amount) || 0;
                          const txnRef = doc(DATABASE, "transection_requests", offerAmountDetails?.doc_id);
                          await runTransaction(DATABASE, async (transaction) => {
                            const txnSnap = await transaction.get(txnRef);
                            const liveTxnData = txnSnap.data();
                            if (!txnSnap.exists()) {
                              throw new Error("Transaction does not exist");
                            }

                            if (liveTxnData?.balance_restored === true) {
                              console.log(`⚠️ [FULL REJECTION] Transaction ${offerAmountDetails?.doc_id} already restored, skipping duplicate.`);
                              return;
                            }

                            if (liveTxnData?.otp_verify !== true) {
                              console.log(`ℹ️ [FULL REJECTION] OTP not verified for ${offerAmountDetails?.doc_id}. No restore required.`);
                              return;
                            }

                            const userRef = doc(DATABASE, "users", offerAmountDetails?.user_id);
                            const userSnap = await transaction.get(userRef);
                            if (!userSnap.exists()) {
                              throw new Error("User does not exist");
                            }

                            transaction.update(userRef, {
                              net_balance: increment(amountToRestore),
                              _last_balance_sync: serverTimestamp(),
                            });
                            transaction.update(txnRef, {
                              balance_restored: true,
                            });
                          });

                            // Update ledger entry: set current_balance back to previous_balance
                            try {
                              const ledgersQuery = query(
                                collection(DATABASE, "ledgers"),
                                where("doc_id", "==", offerAmountDetails?.doc_id),
                                where("user_id", "==", offerAmountDetails?.user_id)
                              );
                              const ledgersSnapshot = await getDocs(ledgersQuery);
                              if (!ledgersSnapshot.empty) {
                                for (const ledgerDoc of ledgersSnapshot.docs) {
                                  const ledgerData = ledgerDoc.data();
                                  await updateDoc(ledgerDoc.ref, {
                                    current_balance: ledgerData.previous_balance,
                                    request_status: 4,
                                  });
                                }
                                console.log(`✅ Ledger updated for rejected withdrawal ${offerAmountDetails?.doc_id}`);
                              }
                            } catch (ledgerError) {
                              console.error(`⚠️ Could not update ledger for rejected withdrawal:`, ledgerError);
                            }

                            console.log(`✅ FullWithdrawModel: Balance restoration transaction completed for rejected conditional withdrawal ${offerAmountDetails?.doc_id}`);
                        }
                        
                        const updateData = {
                          request_status: 4, // Rejected
                          request_approval_time: serverTimestamp(),
                        };
                        await updateDoc(
                          doc(
                            DATABASE,
                            "transection_requests",
                            offerAmountDetails?.doc_id
                          ),
                          updateData
                        );
                        toast.success("Withdrawal rejected");
                        handleOfferAmountOnSubmit();
                      } catch (error) {
                        console.error("Error rejecting withdraw:", error);
                        toast.error("Failed to reject withdrawal");
                      } finally {
                        setIsLoading2(false);
                      }
                    }}
                    sx={{
                      background: "#c62828 !important",
                      "&:hover": {
                        background: "#b71c1c !important",
                      },
                      "&:disabled": {
                        background: "#ccc !important",
                      },
                    }}
                  />
                </Box>
              </Box>
            </Grid>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 1,
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  borderBottom: "1px solid #CACACA",
                  height: 0,
                  marginRight: 1,
                }}
              />
              <Box sx={{ px: 2, fontWeight: "500", color: "#101010" }}>OR</Box>
              <Box
                sx={{
                  flex: 1,
                  borderBottom: "1px solid #CACACA",
                  height: 0,
                  marginLeft: 1,
                }}
              />
            </Box>

            <Grid item xs={12}>
              <CustomSubmitButton
                disabled={formik.values.profit_loss_percent > 0}
                btnTitle={"Accept Full Withdraw"}
                loading={isLoading1}
                type="button"
                onSubmit={async () => {
                  setIsLoading1(true);
                  try {
                    const updateData = {
                      request_status: 2,
                      request_approval_time: Timestamp.now(),
                      full_withdraw_paid: 0,
                    };
                    await updateDoc(
                      doc(
                        DATABASE,
                        "transection_requests",
                        offerAmountDetails?.doc_id
                      ),
                      updateData
                    );
                    toast.success("Full withdraw accepted");
                    handleOfferAmountOnSubmit();
                  } catch (error) {
                    console.error("Error accepting withdraw:", error);
                    toast.error("Failed to accept full withdraw");
                  } finally {
                    setIsLoading1(false);
                  }
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </form>
    </Dialog>
  );
};

export default FullWithdrawModel;
